import { Router } from '@angular/router';
import { SupabaseClient } from '@supabase/supabase-js';

export async function handleAuthHash(supabase: SupabaseClient, router: Router): Promise<boolean> {
  const hash = window.location.hash.substring(1);
  if (!hash) return false;

  const params = new URLSearchParams(hash);

  if (params.has('error')) {
    history.replaceState({}, '', window.location.pathname);
    router.navigate(['/login'], {
      queryParams: { error: params.get('error_code') ?? params.get('error') },
    });
    return true;
  }

  const access_token = params.get('access_token');
  const refresh_token = params.get('refresh_token');

  if (access_token && refresh_token) {
    const { error } = await supabase.auth.setSession({ access_token, refresh_token });
    history.replaceState({}, '', window.location.pathname);

    if (error) {
      router.navigate(['/login'], {
        queryParams: { error: 'session_failed' },
      });
      return true;
    }

    router.navigate(['/dashboard']);
    return true;
  }

  return false;
}
